import React, { useContext } from "react";

import classnames from "classnames/bind";
import styles from "./Legend.module.scss";

import { ChartTooltipContext } from "../ChartTooltip";
import { CircleIcon, LineIcon, SquareIcon } from "../Icons";
import { OTHER } from "../../constants";

import type { LegendProps } from "./types";

const cx = classnames.bind(styles);

const Legend = ({
  scale,
  orientation = "vertical",
  onMouseOver,
  active,
  data,
  left = 0,
}: LegendProps) => {
  const tooltip = useContext(ChartTooltipContext);

  const onMouseEnter = (event: React.MouseEvent<HTMLLIElement>, point: any) => {
    if (onMouseOver) {
      onMouseOver(event, point);
    }
  };

  const onMouseLeave = (event: React.MouseEvent<HTMLLIElement>) => {
    if (tooltip?.hideTooltip) {
      const { hideTooltip } = tooltip;
      hideTooltip();
    }

    if (onMouseOver) {
      onMouseOver(event, undefined);
    }
  };

  return (
    <ul
      style={{ paddingLeft: left }}
      className={cx("container", {
        vertical: orientation === "vertical",
        horizontal: orientation === "horizontal",
      })}
    >
      {data.map((point, index) => {
        const { label, value, variant = "circle" } = point;
        const fill = label === OTHER.LABEL ? OTHER.COLOUR : scale(label);

        return (
          <li
            key={`${label}-${value}-${index}`}
            className={cx("item", {
              notHovered: active !== undefined && active !== label,
            })}
            onMouseEnter={(event) => onMouseEnter(event, { ...point, fill })}
            onMouseLeave={onMouseLeave}
          >
            <svg
              width={variant === "circle" ? 12 : 20}
              height={12}
              className={cx("indicator")}
            >
              {variant === "bar" ? <SquareIcon fill={fill} /> : null}

              {variant === "scatter-plot" ? <CircleIcon fill={fill} /> : null}

              {variant === "circle" ? <CircleIcon fill={fill} /> : null}

              {variant === "line" ? <LineIcon stroke={fill} /> : null}

              {variant === "threshold" ? (
                <LineIcon
                  stroke="#D83B3E"
                  isDashed
                />
              ) : null}
            </svg>

            <p className={cx("text")}>{label}</p>
          </li>
        );
      })}
    </ul>
  );
};

export default Legend;
